import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { adminSignInReducer } from "./admin-slices/signin-slice/slice";
import { singleOwnerReducer } from "./admin-slices/single-property-slice/slice";
import { clientReducer } from "./client-slice/slice";
import { ownerPortalPropertyReducer } from "./owner-portal-property-slice/slice";
import { referralPageReducer } from "./referral-slice/slice";
import { signupReducer } from "./signup-slice/slice";
import { submitEvidenceReducer } from "./submit-evidence-slice/slice";

// Slices read from outside pages/admin (public pages, client portal, or both) - these
// load for every visitor regardless of which area of the app they're in. Everything
// admin-only is injected lazily from layout/AdminLayout via injectReducers() below, so a
// public/client visitor never downloads code for features they can't reach.
const coreReducers = {
  signup: signupReducer,
  adminSignIn: adminSignInReducer,
  client: clientReducer,
  referrals: referralPageReducer,
  submitEvidenceSlice: submitEvidenceReducer,
  ownerPortalProperty: ownerPortalPropertyReducer,
  singleOwner: singleOwnerReducer,
};

let injectedReducers = {};

const createRootReducer = () => combineReducers({ ...coreReducers, ...injectedReducers });

export const store = configureStore({
  reducer: createRootReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const injectReducers = (reducers) => {
  const newKeys = Object.keys(reducers).filter((key) => !injectedReducers[key]);
  if (!newKeys.length) return;

  injectedReducers = { ...injectedReducers, ...reducers };
  store.replaceReducer(createRootReducer());
};
